module.exports = __webpack_public_path__ + "img/completado_c.4f121ec8.png";